import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import Tour from "reactour";

// {
/* <Reactour
  lastStepNextButton={
    <TrackedButton
      className="tour__btn--finish"
      variant="primary"
      onClick={this.onRequestClose}
      action="tourFinishClick"
      label={this.props.id}
    >
      Finish
    </TrackedButton>
  }
  steps={this.props.steps}
  isOpen={run}
  onRequestClose={this.onRequestClose}
  update={this.props.hashes[this.props.id] || ""}
/>; */
// }

type Props = {};

// transaction-manager-filter-fieldName
// transaction-manager-missing-transactions
// transaction-manager-pagination
// transaction-manager-transactions
// btn--report-bad-job
// btn--download-data
// transaction-manager-missing-transactions

const steps = [
  {
    selector: ".new-account-summary",
    content:
      "Summary of the different accounts and periods. A blue badge indicates the period is reconciled. Edit start/end dates and start/end balances. Rename accounts.",
  },
  {
    selector: ".new-transactions",
    content:
      "Transactions. Edit transaction fields like date, description, amount, etc. Include/exclude transactions from the output. Add missing transactions.",
  },
  {
    selector: ".new-transactions-bulk-operations",
    content:
      "Apply changes in bulk. Assign transactions to a different account/period.",
  },

  {
    selector: ".btn--download-data",
    content:
      "Click here to download the data. DocuClipper supported formats include Excel, QuickBooks, Xero and other third party applications.",
  },

  // ...
];

export const NewTransactionManagerTour: React.FC<Props> = ({}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)} variant="secondary">
        <FontAwesomeIcon icon="play" />
        <span className="ml-1">Tutorial</span>
      </Button>
      <Tour steps={steps} isOpen={open} onRequestClose={() => setOpen(false)} />
    </>
  );
};
export default NewTransactionManagerTour;
